import {
  DEFAULT_CENTER_LOCATION,
  DEFAULT_ZOOM_LEVEL,
  DEFAULT_AUTOCOMPLETE_CENTER_LOCATION,
  DEFAULT_AUTOCOMPLETE_RADIUS,
} from "./appConfig";

const MAX_API_GOOGLE_AUTOCOMPLETE_RADIUS = 50000;

interface TrpSettings {
  apiKey: string;
  countryRestriction: string;
  travelMode: string;
  zoomLevel: number;
  geocodeAPIUrlProd?: string;
  mapsAPIUrlProd?: string;
  directionsAPIUrlProd?: string;
}

interface RegionCorners {
  northwest: { lat: number; lng: number };
  northeast: { lat: number; lng: number };
  southwest: { lat: number; lng: number };
  southeast: { lat: number; lng: number };
}

interface ConfigSettings {
  apiKey: string;
  center: { lat: number; lng: number };
  zoom: number;
  autocompleteCenter: { latitude: number; longitude: number };
  autocompleteRadius: number;
  regionCorners: RegionCorners | null;
}

export const getConfigSettings = (): ConfigSettings => {
  const settings: TrpSettings = window.trpSettings || {
    apiKey: "",
    countryRestriction: "",
    travelMode: "",
    zoomLevel: DEFAULT_ZOOM_LEVEL,
  };

  const apiKey =
    process.env.NODE_ENV === "development"
      ? settings.apiKey || process.env.REACT_APP_API_KEY || ""
      : "";

  // Get region corners for rectangular location restriction
  const rawRegionCorners = window.trpSettings?.regionCorners;
  const regionCorners: RegionCorners | null =
    rawRegionCorners &&
    rawRegionCorners.northwest &&
    rawRegionCorners.northeast &&
    rawRegionCorners.southwest &&
    rawRegionCorners.southeast
      ? {
          northwest: rawRegionCorners.northwest,
          northeast: rawRegionCorners.northeast,
          southwest: rawRegionCorners.southwest,
          southeast: rawRegionCorners.southeast,
        }
      : null;

  // Calculate center from region corners if available, otherwise use default
  const center = regionCorners
    ? {
        lat: (regionCorners.northwest.lat + regionCorners.southeast.lat) / 2,
        lng: (regionCorners.northwest.lng + regionCorners.southeast.lng) / 2,
      }
    : DEFAULT_CENTER_LOCATION;

  const zoom = (() => {
    const parsedZoom = Number(settings.zoomLevel);
    return !isNaN(parsedZoom) && parsedZoom >= 0 && parsedZoom <= 21
      ? parsedZoom
      : DEFAULT_ZOOM_LEVEL;
  })();

  // Use center of coverage area for autocomplete
  const autocompleteCenter = {
    latitude: center.lat,
    longitude: center.lng,
  };

  // Always use default radius (no longer a user setting)
  const autocompleteRadius = DEFAULT_AUTOCOMPLETE_RADIUS;

  return {
    apiKey,
    center,
    zoom,
    autocompleteCenter,
    autocompleteRadius,
    regionCorners,
  };
};
